export enum IconName {
	CHECK_CIRCLE_ICON = 'CheckCircleIcon',
	ARROW_RIGHT_CIRCLE_ICON = 'ArrowRightCircleIcon',
	EXCLAMATION_TRIANGLE_ICON = 'ExclamationTriangleIcon',
	CLOCK_ICON = 'ClockIcon',
}

export enum IconType {
	SUCCESS = 'success',
	WARNING = 'warning',
	ERROR = 'error',
}

export enum IconSize {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}
